import { useMemo, useState } from 'react'
import type { EligibilityFormData } from '../types'
import type { LocationOption } from './types'

type UseLocationSelectionControlsArgs = {
  bothAvailable: boolean
  continueDisabled: boolean
  effectiveLocation: string
  formData: EligibilityFormData
  isError: boolean
  isPending: boolean
  onContinue: (locationValue?: string) => void
  selectedLocation?: LocationOption
  updateFormData: (data: Partial<EligibilityFormData>) => void
}

export function useLocationSelectionControls({
  bothAvailable,
  continueDisabled,
  effectiveLocation,
  formData,
  isError,
  isPending,
  onContinue,
  selectedLocation,
  updateFormData
}: UseLocationSelectionControlsArgs) {
  const [transmissionError, setTransmissionError] = useState<string | null>(null)

  const isContinueButtonDisabled = useMemo(
    () => !selectedLocation || isPending || isError || continueDisabled,
    [continueDisabled, isError, isPending, selectedLocation]
  )

  const handleTransmissionChange = (value: string) => {
    setTransmissionError(null)
    updateFormData({ transmissionType: value })
  }

  const handleContinueClick = () => {
    if (continueDisabled) {
      return
    }

    if (bothAvailable && !formData.transmissionType) {
      setTransmissionError('Please select a transmission type to continue.')
      return
    }

    setTransmissionError(null)
    onContinue(effectiveLocation)
  }

  return {
    handleContinueClick,
    handleTransmissionChange,
    isContinueButtonDisabled,
    transmissionError
  }
}
